import { useEffect, useRef, type RefObject } from 'react'

/**
 * A field that takes the cursor as it arrives — the one a sheet opens for. Done here rather
 * than with `autoFocus`, which is set once by the browser before React has a say, so a field
 * inside a dialog that portals itself after the first paint is never the one it lands on.
 */
export function useFocusOnMount<T extends HTMLElement>(): RefObject<T | null> {
  const ref = useRef<T>(null)
  useEffect(() => {
    const field = ref.current
    field?.focus()
    // What it opened holding goes with the cursor, where it is something to type over.
    if (field instanceof HTMLInputElement) {
      field.select()
    }
  }, [])
  return ref
}
